'use client';
import React from 'react';
import { CategoryBreadcrumbs as SharedCategoryBreadcrumbs } from '@launchstore/shared-puck';
import type { CategoryBreadcrumbsProps } from '@launchstore/shared-puck';
import { useCategory } from '@lib/hooks/useCategory';

const SharedCategoryBreadcrumbsRender = (SharedCategoryBreadcrumbs as any).render;

const CategoryBreadcrumbsImpl: React.FC<CategoryBreadcrumbsProps> = (props) => {
  const { category, countryCode } = useCategory() as any;
  return (
    <SharedCategoryBreadcrumbsRender
      {...(props as any)}
      category={category}
      countryCode={countryCode}
    />
  );
};

export const CategoryBreadcrumbs: any = { ...SharedCategoryBreadcrumbs, render: (props: any) => <CategoryBreadcrumbsImpl {...props} /> };
export default CategoryBreadcrumbs;
